<mat-form-field color="secondary" [hideRequiredMarker]="!isRequired">
  <mat-select [formControl]="countrySelect" placeholder="Country" (selectionChange)="onChange($event.value)" required>
    <mat-option *ngFor="let country of countries" [value]="country.code">
      {{country.name}}
    </mat-option>
  </mat-select>
  <mat-error *ngIf="countrySelect.invalid">{{getEmptyMessage()}}</mat-error>
</mat-form-field>